import { useAuthStore } from 'api/swr'

export type PermissionKey =
  | 'proCpt'
  | 'libraryTabConfRc'
  | 'sendUpdateAnnouncement'
  | 'deleteAvatar'

export type PermissionsMap = Partial<Record<PermissionKey, boolean>>

export const usePermissions = () => {
  const featurePermissions = useAuthStore(
    (state) => (state.auth?.featurePermissions ?? {}) as PermissionsMap,
  )

  return {
    permissions: featurePermissions,
    can: (key: PermissionKey) => !!featurePermissions[key],
  }
}

export const useProCptPermission = () => {
  const canSetProCpt = useAuthStore(
    (state) => !!state.auth?.featurePermissions?.proCpt,
  )

  return {
    canSetProCpt,
    isLoading: false,
  }
}

export const getProPermissionErrorMessage = (err?: { message?: string }) => {
  const msg = err?.message || ''
  if (msg.includes('no permission')) {
    return '你没有 pro 组件设置权限，请联系管理员'
  }
  return msg || '保存失败，请稍后重试'
}
